import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {AgencyWidgetSettingResponse} from "fello-model";
import {StateTransferResolver, WidgetApiService} from "fello-common";
import {delay, retryWhen} from "rxjs/operators";
import {TransferState} from "@angular/platform-browser";
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: "root"
})
export class AgencyWidgetSettingResponseResolver
  extends StateTransferResolver<AgencyWidgetSettingResponse>
  implements Resolve<AgencyWidgetSettingResponse>
{
  constructor(private widgetApiService: WidgetApiService, transferState: TransferState, @Inject(PLATFORM_ID) private _platformId: Object) {
    super(transferState, _platformId);
  }

  resolve2(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AgencyWidgetSettingResponse> {
    const widgetId = route.paramMap.get("widgetId")!;

    return this.widgetApiService.getWidgetSettings(widgetId).pipe(retryWhen(err => err.pipe(delay(4000))));
  }
}
